import '../../assets/list-option.css';
import { jsxs as a, jsx as t } from "react/jsx-runtime";
import { faCheck as l } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon as m } from "@fortawesome/react-fontawesome";
import h from "clsx";
import { forwardRef as d } from "react";
const f = "_option_1qq2h_1", q = "_option_content_1qq2h_27", w = "_option_icon_wrapper_1qq2h_33", N = "_option_icon_1qq2h_33", o = {
  option: f,
  option_content: q,
  option_icon_wrapper: w,
  option_icon: N
}, x = d((i, e) => {
  const { children: p, className: c, isSelected: n = !1, isHighlighted: s = !1, iconSelected: r, ..._ } = i;
  return /* @__PURE__ */ a(
    "li",
    {
      ..._,
      ref: e,
      role: "option",
      className: h(o.option, c),
      "aria-selected": n,
      "data-highlighted": s,
      children: [
        /* @__PURE__ */ t("div", { className: o.option_content, children: p }),
        n && /* @__PURE__ */ t("div", { className: o.option_icon_wrapper, children: r ?? /* @__PURE__ */ t(m, { className: o.option_icon, icon: l }) })
      ]
    }
  );
});
x.displayName = "Combobox.Content.List.Option";
export {
  x as ListOption
};
